import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  Checkbox,
  Button,
  IconButton,
  FormControlLabel,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import styled from 'styled-components'
import WarningCircle from 'Components/Icons/WarningCircle'

const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;
`

const Title = styled.h2`
  margin: 16px 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
`

const Subtitle = styled.p`
  margin: 0;
  color: #444;
  font-size: 15px;
`

const ConfirmationBox = styled.div`
  background: #f5f6fa;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
`

const ConfirmationText = styled.p`
  margin: 0 0 10px;
  font-weight: 600;
  font-size: 14px;
`

const ConfirmationList = styled.ul`
  margin: 0 0 16px;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.7;
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`

const CancelButton = styled(Button)`
  && {
    border-radius: 8px;
    padding: 10px 40px;
    font-weight: 700;
    border-color: #1a1a2e;
    color: #1a1a2e;
  }
`

const DownloadButton = styled(Button)`
  && {
    border-radius: 8px;
    padding: 10px 40px;
    font-weight: 700;
    background-color: ${({ disabled }) => (disabled ? undefined : '#EE4360')};
    color: ${({ disabled }) => (disabled ? undefined : '#fff')};
  }
`

const SensitiveDataModal = ({ open, onClose, onConfirm, isBulk }) => {
  const [accepted, setAccepted] = useState(false)

  useEffect(() => {
    if (!open) setAccepted(false)
  }, [open])

  const subject = isBulk ? 'these files' : 'this file'
  const buttonLabel = isBulk ? 'Download all files' : 'Download file'

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent style={{ padding: '40px 48px 40px' }}>
        <IconButton
          onClick={onClose}
          size="small"
          style={{ position: 'absolute', top: 12, right: 12 }}
        >
          <CloseIcon />
        </IconButton>

        <Header>
          <WarningCircle />
          <Title>Sensitive data warning</Title>
          <Subtitle>
            {isBulk
              ? 'These files may contain personal or confidential user data.'
              : 'This file may contain personal or confidential user data.'}
          </Subtitle>
        </Header>

        <ConfirmationBox>
          <ConfirmationText>
            By downloading {subject}, you confirm that:
          </ConfirmationText>
          <ConfirmationList>
            <li>
              You will store and handle this data according to company policy
            </li>
            <li>
              {isBulk
                ? 'You will not share these files and will delete them when they are no longer required'
                : 'You will not share this file and will delete it when it is no longer required'}
            </li>
          </ConfirmationList>
          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={e => setAccepted(e.target.checked)}
              />
            }
            label="I understand and accept"
          />
        </ConfirmationBox>

        <Footer>
          <CancelButton variant="outlined" onClick={onClose}>
            Cancel
          </CancelButton>
          <DownloadButton
            variant="contained"
            disabled={!accepted}
            onClick={onConfirm}
          >
            {buttonLabel}
          </DownloadButton>
        </Footer>
      </DialogContent>
    </Dialog>
  )
}

export default SensitiveDataModal
